<script>
import { mapState } from 'vuex';
import { getAsset } from '@/scripts/utils';

export default {
  name: 'Slider',
  props: {
    banners: {
      type: Array,
    },
  },
  data() {
    return {
      intervalId: null,
      activeSlide: 0,
    };
  },
  watch: {
    banners() {
      this.run();
    },
  },
  computed: {
    ...mapState([]),
    allBanners() {
      const { banners } = this;
      let result = [getAsset(null, { fallback: 'png/slider/background.png' })];

      if (!banners || !banners.length) return result;

      result = banners.map(({ url }) => url);

      return result;
    },
  },
  created() {
    this.run();
  },
  mounted() {},
  methods: {
    run() {
      const { allBanners, intervalId } = this;

      if (intervalId) {
        this.activeSlide = 0;

        clearInterval(intervalId);
      }

      this.intervalId = setInterval(() => {
        this.activeSlide = (this.activeSlide + 1) % allBanners.length;
      }, 5000);
    },
  },
};
</script>

<template>
  <div class="slider">
    <div class="slider__content">
      <div
        v-for="(url, index) in allBanners"
        class="slider__item"
        :class="{ 'is-active': activeSlide === index }"
        :key="index"
      >
        <img :src="url" />
      </div>
    </div>
    <div v-if="allBanners.length > 1" class="slider__dot">
      <div
        v-for="(url, index) in allBanners"
        class="slider__dot-item"
        :class="{ 'is-active': activeSlide === index }"
        :key="index"
        @click="activeSlide = index"
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.slider {
  width: 100%;
  position: relative;
  padding-top: 17.06%;

  &:before {
    display: block;
    content: '';
    width: 100%;
  }

  &__content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  &__item {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 22px;
    transition: all 0.5s;
    user-select: none;

    img {
      display: flex;
      object-fit: contain;
      height: 100%;
      width: 100%;
    }

    &.is-active {
      opacity: 1;
      visibility: visible;
    }
  }

  &__dot {
    position: absolute;
    bottom: 13px;
    right: 25px;
    display: flex;
    align-items: center;
  }

  &__dot-item {
    border-radius: 50%;
    width: 6px;
    height: 6px;
    background-color: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    margin: 3px;
    transition: all 0.2s;

    &:hover,
    &.is-active {
      background: #fff;
    }
  }
}

@media (max-width: $mobile) {
  .slider {
    padding-top: 68.8%;

    &__item {
      border-radius: 0;
    }

    &__dot {
      right: auto;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
